var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificCheckin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFF8E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1150_13467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#paint0_linear_1150_13467)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1150_13467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6847 6.99276C12.9756 6.99276 12.2627 6.98903 11.5536 6.99276C11.1953 6.99276 11.0124 7.19057 11.0012 7.54513C10.9938 7.7392 11.0012 7.93701 10.9676 8.12735C10.9229 8.36247 10.7288 8.48937 10.4862 8.48564C10.2585 8.48564 10.0607 8.35501 10.0271 8.13108C9.9301 7.48541 9.96369 6.86587 10.4974 6.38442C10.7736 6.13809 11.0983 6 11.4752 6C13.2965 6 15.1141 6 16.9354 6C17.5848 6 17.9991 6.42547 17.9991 7.07487C17.9991 10.027 17.9991 12.9792 17.9991 15.9314C17.9991 16.4539 17.7528 16.7972 17.2526 16.9652C16.3009 17.2861 15.3492 17.6034 14.3938 17.9169C13.6362 18.1669 13.0054 17.7079 12.9942 16.9055C12.9942 16.7748 12.9942 16.6442 12.9942 16.4912C12.5016 16.4912 12.0351 16.4912 11.5685 16.4912C10.6541 16.4912 10.0047 15.853 9.99355 14.9349C9.99355 14.6475 9.98981 14.3564 9.99355 14.069C9.99728 13.7144 10.1988 13.4905 10.5049 13.4942C10.8072 13.4942 11.0012 13.7182 11.005 14.0802C11.0087 14.375 11.005 14.6736 11.005 14.9722C11.0087 15.2708 11.1766 15.4798 11.464 15.491C11.9604 15.5096 12.4605 15.4947 12.9905 15.4947V15.2036C12.9905 12.8934 12.998 10.5794 12.9868 8.26917C12.9868 7.70188 14.5915 7.25775 15.1438 6.99276H13.6847Z",
    fill: "url(#paint1_linear_1150_13467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4931 10.3971C8.4931 9.92683 8.4931 9.48643 8.4931 9.0423C8.4931 8.78478 8.54535 8.55338 8.80287 8.44141C9.06413 8.32572 9.26566 8.44888 9.44854 8.63549C10.0532 9.24383 10.6615 9.84845 11.2661 10.4568C11.5834 10.774 11.5796 11.0204 11.2661 11.3413C10.6615 11.9497 10.0532 12.5543 9.44481 13.1626C9.2694 13.338 9.08279 13.4612 8.82153 13.3604C8.55282 13.2559 8.48937 13.032 8.4931 12.7745C8.4931 12.3229 8.4931 11.8713 8.4931 11.3936C8.26171 11.3936 8.0527 11.3936 7.8437 11.3936C7.39957 11.3936 6.95544 11.3973 6.51131 11.3936C6.20527 11.3824 6 11.1734 6 10.8935C6 10.6173 6.21647 10.4008 6.51131 10.3971C7.15698 10.3933 7.80638 10.3971 8.48937 10.3971H8.4931Z",
    fill: "url(#paint2_linear_1150_13467)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1150_13467",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1150_13467",
    x1: 13.9917,
    y1: 6,
    x2: 13.9917,
    y2: 17.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1150_13467",
    x1: 8.75132,
    y1: 8.39648,
    x2: 8.75132,
    y2: 13.3967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificCheckin);
export default __webpack_public_path__ + "static/media/notific_checkin.427003babb1f2bfd55a6d48d8b83b6cc.svg";
export { ForwardRef as ReactComponent };